/* tslint:disable */
type InsiderType =
  'INDIVIDUAL' |
  'NON-INDIVIDUAL';
module InsiderType {
  export const INDIVIDUAL: InsiderType = 'INDIVIDUAL';
  export const NON_INDIVIDUAL: InsiderType = 'NON-INDIVIDUAL';
  export function values(): InsiderType[] {
    return [
      INDIVIDUAL,
      NON_INDIVIDUAL
    ];
  }
}

export { InsiderType }